<template>
  <div>
    <div class="w-full">
      <div
        class="container mx-auto max-w-[1200px]"
        style="min-height: 70vh !important"
      >
        <!-- Notification List View -->
        <div class="py-10 px-6" v-if="notificationIndex == null">
          <div
            class="font-bold text-2xl pb-6 flex items-center gap-3 text-slate-800"
          >
            Notifications
            <span
              class="bg-blues flex items-center justify-center text-white w-7 h-7 text-[10px] font-black rounded-full"
              v-if="total_count"
            >
              {{ total_count }}
            </span>
          </div>

          <div class="flex flex-col gap-3">
            <div
              v-if="notificationList.length != 0"
              class="flex flex-col gap-3"
            >
              <div
                v-for="(notifi, index) in notificationList"
                :key="notifi.id"
                @click="setNotificationTab(index)"
              >
                <div
                  @click="notifyclick(notifi.id)"
                  class="relative flex justify-between border-2 transition-all duration-300 gap-4 py-4 px-6 rounded-2xl cursor-pointer"
                  :class="{
                    /* UNREAD: Vibrant, White, Blue border */
                    'bg-white border-blue-400 shadow-md ring-1 ring-blue-50 hover:bg-blue-50':
                      !notifi.read,
                    /* READ: Muted Slate, subtle border */
                    'bg-white border-slate-200 hover:bg-slate-50/80 hover:border-slate-300':
                      notifi.read,
                  }"
                >
                  <div class="flex items-center gap-4 w-full">
                    <div
                      class="p-2 rounded-xl transition-colors"
                      :class="
                        !notifi.read
                          ? 'bg-blue-50 text-blue-600'
                          : 'bg-slate-200 text-slate-400'
                      "
                    >
                      <img
                        v-if="notifi.read"
                        src="@/assets/newd/Vector(2).svg"
                        class="w-4 h-4 opacity-40 grayscale"
                        alt="read"
                      />
                      <img
                        v-else
                        src="@/assets/newd/Group(1).svg"
                        class="w-4 h-4"
                        alt="unread"
                      />
                    </div>

                    <p
                      class="text-sm transition-colors"
                      :class="{
                        'font-bold text-slate-900': !notifi.read,
                        'font-medium text-slate-500': notifi.read,
                      }"
                    >
                      {{ notifi.topic }}
                    </p>
                  </div>

                  <div class="flex items-center min-w-fit">
                    <span
                      class="text-[11px] font-bold"
                      :class="!notifi.read ? 'text-blue-600' : 'text-slate-400'"
                    >
                      {{
                        new Date(notifi.created_at).toLocaleDateString("en-IN")
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="notificationList.length == 0"
              class="flex flex-col items-center py-20 border-2 border-dashed border-slate-200 rounded-3xl text-slate-400"
            >
              <p class="font-bold">No Notifications Yet</p>
            </div>
          </div>

          <div
            v-if="notificationList.length > 0"
            class="flex justify-center py-8"
          >
            <Pagination
              ref="paginationRef"
              :totalPages="totalPages"
              @page-changed="getNotifications"
            />
          </div>
        </div>

        <!-- Notification Detail View -->
        <div
          class="py-10 px-6 max-w-4xl mx-auto"
          v-if="notificationIndex != null"
        >
          <button
            @click="triggerPage()"
            class="group flex items-center gap-2 bg-slate-100 hover:bg-hover text-slate-600 hover:text-white text-xs font-bold px-5 py-2 rounded-full transition-all"
          >
            <svg
              class="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back
          </button>

          <div
            class="mt-8 bg-white border border-slate-200 rounded-3xl p-8 shadow-sm"
          >
            <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
              <h2 class="font-bold text-2xl text-slate-900">
                {{ selectNotificationData.topic }}
              </h2>
              <span
                class="text-xs bg-blue-50 text-blue-600 px-4 py-1.5 rounded-full font-bold border border-blue-100"
              >
                {{
                  new Date(
                    selectNotificationData.created_at
                  ).toLocaleDateString("en-IN")
                }}
              </span>
            </div>

            <div
              class="prose max-w-none text-slate-600 leading-relaxed text-base bg-slate-50/50 p-6 rounded-2xl border border-slate-100"
            >
              {{ selectNotificationData.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import StudentHeader from "@/components/Student/Header.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Notifications",

  components: {
    StudentHeader,
    Footer,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
  },

  data() {
    return {
      notificationIndex: null,
      selectNotificationData: "",
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
      notificationList: "",
    };
  },

  computed: {
    ...mapGetters("student", ["studentdata"]),
  },

  created() {
    this.getNotifications(1);
  },

  methods: {
    ...mapMutations(["notifyCount"]),

    triggerPage() {
      this.notificationIndex = null;
      this.$nextTick(() => {
        if (this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage);
        }
      });
    },

    setNotificationTab(index) {
      this.notificationIndex = index;
      this.selectNotificationData = this.notificationList[index];
    },

    async getNotifications(page) {
      this.currentPage = page;
      if (!this.studentdata) return;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/notifications/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&page=${page}`
        );
        if (response?.data?.status === 200) {
          this.notifyCount(response.data.count);
          this.notificationList = response.data.data.data;
          this.totalPages = response.data.data.total_page;
          this.total_count = response.data.data.total;
        }
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    },

    notifyclick(id) {
      let formdata = { read: true };
      axios
        .put(
          `${process.env.VUE_APP_API}/update-notification/${id}/?Key=${this.studentdata.studentToken}`,
          formdata
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.getNotifications(this.currentPage);
          }
        })
        .catch((error) => {
          console.error("Error updating notification:", error);
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>